import store from "../store";
export default {
   bind(el, binding) {
    if (!binding.value && !store.state.permissionButtons.includes(binding.value)) {
        el.parentNode.removeChild(el);
    }
  },
};
